// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import ProjectMenu from './Project'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';

class ProjectSg extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })
    }

    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='6' />
                <div className='dv_project_body'>
                    <ProjectMenu activeMenu={4} />
                    <div className='dv_project_body_right'>
                        <div className={`flex-col`}>
                            <div className='dv_banner_wrap'><img src={require("./assets/img/projects/80.jpg")} /></div>
                            <div className='dv_contentbodyEs_wrap'>
                                <div className='dv_trake_change flex-row between'>
                                    <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>走进新加坡国立大学</div>
                                    <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>课程模块介绍</div>
                                    <div className={this.state.currentTab == 2 ? 'tab selected tablast' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>申请须知</div>
                                </div>
                                {this.state.currentTab == 0 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/81.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/82.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/83.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/84.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/85.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/86.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/87.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/88.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/89.jpg")} />
                                    </div>

                                </div>}
                                {this.state.currentTab == 1 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/90.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/91.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/92.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/93.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/94.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/95.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/96.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/97.jpg")} />
                                    </div>

                                </div>}
                                {this.state.currentTab == 2 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/98.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/99.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/100.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/101.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/102.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/103.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/104.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/105.jpg")} />
                                    </div>

                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

        );
    }
}

export default withRouter(ProjectSg);